<template>
    <div class="container py-12">
        <UpdateProfileInformationForm :user="$store.getters.user"/>

        <div class="hidden md:block">
            <div class="py-8">
                <div class="border-t border-gray-200"></div>
            </div>
        </div>

        <UpdatePasswordForm class="mt-6 md:mt-0"/>
    </div>
</template>

<script>

import UpdatePasswordForm from "@/Pages/Profile/Components/UpdatePasswordForm";
import UpdateProfileInformationForm from "@/Pages/Profile/Components/UpdateProfileInformationForm";

export default {
    components: {
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    }
};
</script>
